import { Outlet } from "react-router-dom";

export default function Support() {
  return <Outlet />;
}
